import React from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Card from './Card';
const DisplayCardList = ({ data }) => {
    return (
        <MDBContainer>
            <MDBRow  className='mb-3 mt-3'>
                {
                    data?.map((currdata, index) => {
                        return (
                            <>
                                <MDBCol md="auto" style={{marginTop:"10px"}}>
                                  <Card {...currdata} />
                                </MDBCol>

                            </>
                        )
                    })
                }
            </MDBRow>
        </MDBContainer>
    )
}

export default DisplayCardList